export enum PartnerPrograms {
  INJURED_GADGETS = 'injuredgadgets',
  AKKO = 'akko',
}

export enum PartnerProgramsIds {
  INJURED_GADGETS_ID = 2,
  AKKO_ID = 1,
}
